export default {
  adapter: null,
  payload: {},
  meta: {},
  hooks: {
    before: [],
    done: [],
    fail: []
  }
};